import React, { useState } from "react";
import {
  Dialog,
  DialogActions,
  DialogDescription,
  DialogTitle,
} from "../../design/dialog";
import { Button } from "../../design/button";
import { InformationCircleIcon } from "@heroicons/react/20/solid";

const ContactsLearnMore: React.FC = () => {
  const [open, setOpen] = useState(false);

  const handleAction = () => {
    setOpen(true);
  };

  return (
    <>
      <Button plain onClick={handleAction}>
        <InformationCircleIcon className="w-5 h-5 mr-2" />
      </Button>
      <Dialog open={open} onClose={() => setOpen(false)}>
        <DialogTitle>What are Contacts?</DialogTitle>
        <DialogDescription>
          <p>
            Contacts are individuals associated with a parent or guardian. They
            can be family members, friends, or other individuals who can assist
            in the visitation process.
          </p>
        </DialogDescription>
        <DialogDescription>
          <ul style={{ paddingLeft: "20px", listStyleType: "disc" }}>
            <li>
              <strong>Visibility to Monitors</strong>: If needed, you can
              make certain contacts viewable to supervisors. This can help them
              in managing and coordinating visitations smoothly.
            </li>
            <li>
              <strong>Emergency Contacts</strong>: You can label any contact as
              an emergency contact. These will be highlighted, ensuring that in
              case of any emergency during a visit, supervisors and other
              relevant individuals know exactly who to reach out to.
            </li>
          </ul>
        </DialogDescription>
        <DialogActions>
          <Button plain onClick={() => setOpen(false)}>
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default ContactsLearnMore;
